/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddCustomerWebsiteMutationVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
  acceptedLegalDocuments: ReadonlyArray<GraphQL.LegalDocumentType> | GraphQL.LegalDocumentType;
  domain: GraphQL.Scalars['String']['input'];
  fetchingLocation: GraphQL.InputMaybe<GraphQL.FetchingLocation>;
  httpAuthCredentials: GraphQL.InputMaybe<GraphQL.HttpAuthCredentials>;
  pageCapacity: GraphQL.Scalars['Int']['input'];
  skipValidation: GraphQL.Scalars['Boolean']['input'];
  threeDSecureToken: GraphQL.InputMaybe<GraphQL.Scalars['String']['input']>;
  userAgentSettings: GraphQL.InputMaybe<GraphQL.UserAgentSettingsInput>;
  allowDefaultAlerts: GraphQL.InputMaybe<GraphQL.Scalars['Boolean']['input']>;
  allowDefaultReports: GraphQL.InputMaybe<GraphQL.Scalars['Boolean']['input']>;
}>;


export type AddCustomerWebsiteMutation = { readonly __typename?: 'Mutation', readonly AddCustomerWebsite: { readonly __typename?: 'AddCustomerWebsiteResult', readonly query: { readonly __typename?: 'Query', readonly authenticatedSession: { readonly __typename?: 'AuthenticatedSession', readonly accounts: ReadonlyArray<{ readonly __typename?: 'Account', readonly id: CK.AccountId, readonly invitations: ReadonlyArray<{ readonly __typename?: 'Invitation', readonly id: CK.InvitationId, readonly websiteEmailSettings: ReadonlyArray<{ readonly __typename?: 'WebsiteEmailSettings', readonly alertEmailsSetup: GraphQL.AlertEmailsSetup, readonly isWeeklyReportEnabled: boolean, readonly websiteId: CK.WebsiteId }>, readonly websites: ReadonlyArray<{ readonly __typename?: 'Website', readonly id: CK.WebsiteId }> }>, readonly memberships: ReadonlyArray<{ readonly __typename?: 'AccountMembership', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId }, readonly user: { readonly __typename?: 'User', readonly id: string, readonly legacyId: string }, readonly websites: ReadonlyArray<{ readonly __typename?: 'Website', readonly id: CK.WebsiteId }> }>, readonly users: ReadonlyArray<{ readonly __typename?: 'User', readonly email: string, readonly id: string, readonly legacyId: string, readonly websiteEmailSettings: ReadonlyArray<{ readonly __typename?: 'WebsiteEmailSettings', readonly alertEmailsSetup: GraphQL.AlertEmailsSetup, readonly isWeeklyReportEnabled: boolean, readonly websiteId: CK.WebsiteId }> }>, readonly websites: ReadonlyArray<{ readonly __typename?: 'Website', readonly id: CK.WebsiteId }> }>, readonly memberships: ReadonlyArray<{ readonly __typename?: 'AccountMembership', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId }, readonly user: { readonly __typename?: 'User', readonly id: string, readonly legacyId: string }, readonly websites: ReadonlyArray<{ readonly __typename?: 'Website', readonly id: CK.WebsiteId }> }> } | null }, readonly website: { readonly __typename?: 'Website', readonly domain: string, readonly id: CK.WebsiteId, readonly displayName: string, readonly pageCapacity: number, readonly permittedActions: ReadonlyArray<GraphQL.ActionWithWebsite> } } };

export type AddEndUserWebsiteMutationVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
  acceptedLegalDocuments: ReadonlyArray<GraphQL.LegalDocumentType> | GraphQL.LegalDocumentType;
  domain: GraphQL.Scalars['String']['input'];
  fetchingLocation: GraphQL.InputMaybe<GraphQL.FetchingLocation>;
  httpAuthCredentials: GraphQL.InputMaybe<GraphQL.HttpAuthCredentials>;
  pageCapacity: GraphQL.Scalars['Int']['input'];
  skipValidation: GraphQL.Scalars['Boolean']['input'];
  threeDSecureToken: GraphQL.InputMaybe<GraphQL.Scalars['String']['input']>;
  userAgentSettings: GraphQL.InputMaybe<GraphQL.UserAgentSettingsInput>;
  allowDefaultAlerts: GraphQL.InputMaybe<GraphQL.Scalars['Boolean']['input']>;
  allowDefaultReports: GraphQL.InputMaybe<GraphQL.Scalars['Boolean']['input']>;
}>;


export type AddEndUserWebsiteMutation = { readonly __typename?: 'Mutation', readonly AddEndUserWebsite: { readonly __typename?: 'AddEndUserWebsiteResult', readonly query: { readonly __typename?: 'Query', readonly authenticatedSession: { readonly __typename?: 'AuthenticatedSession', readonly accounts: ReadonlyArray<{ readonly __typename?: 'Account', readonly id: CK.AccountId, readonly invitations: ReadonlyArray<{ readonly __typename?: 'Invitation', readonly id: CK.InvitationId, readonly websiteEmailSettings: ReadonlyArray<{ readonly __typename?: 'WebsiteEmailSettings', readonly alertEmailsSetup: GraphQL.AlertEmailsSetup, readonly isWeeklyReportEnabled: boolean, readonly websiteId: CK.WebsiteId }>, readonly websites: ReadonlyArray<{ readonly __typename?: 'Website', readonly id: CK.WebsiteId }> }>, readonly memberships: ReadonlyArray<{ readonly __typename?: 'AccountMembership', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId }, readonly user: { readonly __typename?: 'User', readonly id: string, readonly legacyId: string }, readonly websites: ReadonlyArray<{ readonly __typename?: 'Website', readonly id: CK.WebsiteId }> }>, readonly users: ReadonlyArray<{ readonly __typename?: 'User', readonly email: string, readonly id: string, readonly legacyId: string, readonly websiteEmailSettings: ReadonlyArray<{ readonly __typename?: 'WebsiteEmailSettings', readonly alertEmailsSetup: GraphQL.AlertEmailsSetup, readonly isWeeklyReportEnabled: boolean, readonly websiteId: CK.WebsiteId }> }>, readonly websites: ReadonlyArray<{ readonly __typename?: 'Website', readonly id: CK.WebsiteId }> }>, readonly memberships: ReadonlyArray<{ readonly __typename?: 'AccountMembership', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId }, readonly user: { readonly __typename?: 'User', readonly id: string, readonly legacyId: string }, readonly websites: ReadonlyArray<{ readonly __typename?: 'Website', readonly id: CK.WebsiteId }> }> } | null }, readonly website: { readonly __typename?: 'Website', readonly domain: string, readonly id: CK.WebsiteId, readonly displayName: string, readonly pageCapacity: number, readonly permittedActions: ReadonlyArray<GraphQL.ActionWithWebsite> } } };

export type AddTrialWebsiteMutationVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
  acceptedLegalDocuments: ReadonlyArray<GraphQL.LegalDocumentType> | GraphQL.LegalDocumentType;
  domain: GraphQL.Scalars['String']['input'];
  fetchingLocation: GraphQL.InputMaybe<GraphQL.FetchingLocation>;
  httpAuthCredentials: GraphQL.InputMaybe<GraphQL.HttpAuthCredentials>;
  pageCapacity: GraphQL.Scalars['Int']['input'];
  skipValidation: GraphQL.Scalars['Boolean']['input'];
  userAgentSettings: GraphQL.InputMaybe<GraphQL.UserAgentSettingsInput>;
}>;


export type AddTrialWebsiteMutation = { readonly __typename?: 'Mutation', readonly AddTrialWebsite: { readonly __typename?: 'AddTrialWebsiteResult', readonly query: { readonly __typename?: 'Query', readonly authenticatedSession: { readonly __typename?: 'AuthenticatedSession', readonly accounts: ReadonlyArray<{ readonly __typename?: 'Account', readonly id: CK.AccountId, readonly invitations: ReadonlyArray<{ readonly __typename?: 'Invitation', readonly id: CK.InvitationId, readonly websiteEmailSettings: ReadonlyArray<{ readonly __typename?: 'WebsiteEmailSettings', readonly alertEmailsSetup: GraphQL.AlertEmailsSetup, readonly isWeeklyReportEnabled: boolean, readonly websiteId: CK.WebsiteId }>, readonly websites: ReadonlyArray<{ readonly __typename?: 'Website', readonly id: CK.WebsiteId }> }>, readonly memberships: ReadonlyArray<{ readonly __typename?: 'AccountMembership', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId }, readonly user: { readonly __typename?: 'User', readonly id: string, readonly legacyId: string }, readonly websites: ReadonlyArray<{ readonly __typename?: 'Website', readonly id: CK.WebsiteId }> }>, readonly users: ReadonlyArray<{ readonly __typename?: 'User', readonly email: string, readonly id: string, readonly legacyId: string, readonly websiteEmailSettings: ReadonlyArray<{ readonly __typename?: 'WebsiteEmailSettings', readonly alertEmailsSetup: GraphQL.AlertEmailsSetup, readonly isWeeklyReportEnabled: boolean, readonly websiteId: CK.WebsiteId }> }>, readonly websites: ReadonlyArray<{ readonly __typename?: 'Website', readonly id: CK.WebsiteId }> }>, readonly memberships: ReadonlyArray<{ readonly __typename?: 'AccountMembership', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId }, readonly user: { readonly __typename?: 'User', readonly id: string, readonly legacyId: string }, readonly websites: ReadonlyArray<{ readonly __typename?: 'Website', readonly id: CK.WebsiteId }> }> } | null }, readonly website: { readonly __typename?: 'Website', readonly domain: string, readonly id: CK.WebsiteId, readonly displayName: string, readonly pageCapacity: number, readonly permittedActions: ReadonlyArray<GraphQL.ActionWithWebsite> } } };

export type ReviveTrialByAddingWebsiteMutationVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
  acceptedLegalDocuments: ReadonlyArray<GraphQL.LegalDocumentType> | GraphQL.LegalDocumentType;
  domain: GraphQL.Scalars['String']['input'];
  fetchingLocation: GraphQL.InputMaybe<GraphQL.FetchingLocation>;
  httpAuthCredentials: GraphQL.InputMaybe<GraphQL.HttpAuthCredentials>;
  pageCapacity: GraphQL.Scalars['Int']['input'];
  skipValidation: GraphQL.Scalars['Boolean']['input'];
  userAgentSettings: GraphQL.InputMaybe<GraphQL.UserAgentSettingsInput>;
}>;


export type ReviveTrialByAddingWebsiteMutation = { readonly __typename?: 'Mutation', readonly ReviveTrialByAddingWebsite: { readonly __typename?: 'ReviveTrialByAddingWebsiteResult', readonly query: { readonly __typename?: 'Query', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId, readonly isCleanedUp: boolean, readonly isSuitableForTrialRevival: boolean, readonly isTrialBarDisplayed: boolean, readonly isTrialExtensionAllowed: boolean, readonly pageBundle: number | null, readonly phase: GraphQL.AccountPhase, readonly plan: GraphQL.AccountPlan | null, readonly state: GraphQL.AccountState, readonly trialExpirationDate: CK.Timestamp | null, readonly features: ReadonlyArray<{ readonly __typename?: 'AccountFeatureState', readonly feature: GraphQL.AccountFeature, readonly id: CK.ID }>, readonly memberships: ReadonlyArray<{ readonly __typename?: 'AccountMembership', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId }, readonly user: { readonly __typename?: 'User', readonly id: string, readonly legacyId: string }, readonly websites: ReadonlyArray<{ readonly __typename?: 'Website', readonly id: CK.WebsiteId }> }>, readonly premiumTrialOffer: { readonly __typename?: 'AccountPremiumTrialOffer', readonly durationInDays: number, readonly plan: GraphQL.AccountPlan } | null } | null, readonly authenticatedSession: { readonly __typename?: 'AuthenticatedSession', readonly accounts: ReadonlyArray<{ readonly __typename?: 'Account', readonly id: CK.AccountId, readonly invitations: ReadonlyArray<{ readonly __typename?: 'Invitation', readonly id: CK.InvitationId, readonly websiteEmailSettings: ReadonlyArray<{ readonly __typename?: 'WebsiteEmailSettings', readonly alertEmailsSetup: GraphQL.AlertEmailsSetup, readonly isWeeklyReportEnabled: boolean, readonly websiteId: CK.WebsiteId }>, readonly websites: ReadonlyArray<{ readonly __typename?: 'Website', readonly id: CK.WebsiteId }> }>, readonly memberships: ReadonlyArray<{ readonly __typename?: 'AccountMembership', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId }, readonly user: { readonly __typename?: 'User', readonly id: string, readonly legacyId: string }, readonly websites: ReadonlyArray<{ readonly __typename?: 'Website', readonly id: CK.WebsiteId }> }>, readonly users: ReadonlyArray<{ readonly __typename?: 'User', readonly email: string, readonly id: string, readonly legacyId: string, readonly websiteEmailSettings: ReadonlyArray<{ readonly __typename?: 'WebsiteEmailSettings', readonly alertEmailsSetup: GraphQL.AlertEmailsSetup, readonly isWeeklyReportEnabled: boolean, readonly websiteId: CK.WebsiteId }> }>, readonly websites: ReadonlyArray<{ readonly __typename?: 'Website', readonly id: CK.WebsiteId }> }>, readonly memberships: ReadonlyArray<{ readonly __typename?: 'AccountMembership', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId }, readonly user: { readonly __typename?: 'User', readonly id: string, readonly legacyId: string }, readonly websites: ReadonlyArray<{ readonly __typename?: 'Website', readonly id: CK.WebsiteId }> }> } | null }, readonly website: { readonly __typename?: 'Website', readonly domain: string, readonly id: CK.WebsiteId, readonly displayName: string, readonly pageCapacity: number, readonly permittedActions: ReadonlyArray<GraphQL.ActionWithWebsite> } } };


export const AddCustomerWebsiteDocument = gql`
    mutation AddCustomerWebsite($accountId: AccountId!, $acceptedLegalDocuments: [LegalDocumentType!]!, $domain: String!, $fetchingLocation: FetchingLocation, $httpAuthCredentials: HttpAuthCredentials, $pageCapacity: Int!, $skipValidation: Boolean!, $threeDSecureToken: String, $userAgentSettings: UserAgentSettingsInput, $allowDefaultAlerts: Boolean, $allowDefaultReports: Boolean) {
  AddCustomerWebsite(
    accountId: $accountId
    acceptedLegalDocuments: $acceptedLegalDocuments
    domain: $domain
    fetchingLocation: $fetchingLocation
    httpAuthCredentials: $httpAuthCredentials
    pageCapacity: $pageCapacity
    skipValidation: $skipValidation
    threeDSecureToken: $threeDSecureToken
    userAgentSettings: $userAgentSettings
    allowDefaultAlerts: $allowDefaultAlerts
    allowDefaultReports: $allowDefaultReports
  ) {
    query {
      authenticatedSession {
        accounts {
          id
          invitations {
            id
            websiteEmailSettings {
              alertEmailsSetup
              isWeeklyReportEnabled
              websiteId
            }
            websites {
              id
            }
          }
          memberships {
            account {
              id
            }
            user {
              id
              legacyId
            }
            websites {
              id
            }
          }
          users {
            email
            id
            legacyId
            websiteEmailSettings {
              alertEmailsSetup
              isWeeklyReportEnabled
              websiteId
            }
          }
          websites {
            id
          }
        }
        memberships {
          account {
            id
          }
          user {
            id
            legacyId
          }
          websites {
            id
          }
        }
      }
    }
    website {
      domain
      id
      displayName
      pageCapacity
      permittedActions
    }
  }
}
    `;
export type AddCustomerWebsiteMutationFn = Apollo.MutationFunction<AddCustomerWebsiteMutation, AddCustomerWebsiteMutationVariables>;

/**
 * __useAddCustomerWebsiteMutation__
 *
 * To run a mutation, you first call `useAddCustomerWebsiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCustomerWebsiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCustomerWebsiteMutation, { data, loading, error }] = useAddCustomerWebsiteMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      acceptedLegalDocuments: // value for 'acceptedLegalDocuments'
 *      domain: // value for 'domain'
 *      fetchingLocation: // value for 'fetchingLocation'
 *      httpAuthCredentials: // value for 'httpAuthCredentials'
 *      pageCapacity: // value for 'pageCapacity'
 *      skipValidation: // value for 'skipValidation'
 *      threeDSecureToken: // value for 'threeDSecureToken'
 *      userAgentSettings: // value for 'userAgentSettings'
 *      allowDefaultAlerts: // value for 'allowDefaultAlerts'
 *      allowDefaultReports: // value for 'allowDefaultReports'
 *   },
 * });
 */
export function useAddCustomerWebsiteMutation(baseOptions?: Apollo.MutationHookOptions<AddCustomerWebsiteMutation, AddCustomerWebsiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCustomerWebsiteMutation, AddCustomerWebsiteMutationVariables>(AddCustomerWebsiteDocument, options);
      }
export type AddCustomerWebsiteMutationHookResult = ReturnType<typeof useAddCustomerWebsiteMutation>;
export type AddCustomerWebsiteMutationResult = Apollo.MutationResult<AddCustomerWebsiteMutation>;
export type AddCustomerWebsiteMutationOptions = Apollo.BaseMutationOptions<AddCustomerWebsiteMutation, AddCustomerWebsiteMutationVariables>;
export const AddEndUserWebsiteDocument = gql`
    mutation AddEndUserWebsite($accountId: AccountId!, $acceptedLegalDocuments: [LegalDocumentType!]!, $domain: String!, $fetchingLocation: FetchingLocation, $httpAuthCredentials: HttpAuthCredentials, $pageCapacity: Int!, $skipValidation: Boolean!, $threeDSecureToken: String, $userAgentSettings: UserAgentSettingsInput, $allowDefaultAlerts: Boolean, $allowDefaultReports: Boolean) {
  AddEndUserWebsite(
    accountId: $accountId
    acceptedLegalDocuments: $acceptedLegalDocuments
    domain: $domain
    fetchingLocation: $fetchingLocation
    httpAuthCredentials: $httpAuthCredentials
    pageCapacity: $pageCapacity
    skipValidation: $skipValidation
    threeDSecureToken: $threeDSecureToken
    userAgentSettings: $userAgentSettings
    allowDefaultAlerts: $allowDefaultAlerts
    allowDefaultReports: $allowDefaultReports
  ) {
    query {
      authenticatedSession {
        accounts {
          id
          invitations {
            id
            websiteEmailSettings {
              alertEmailsSetup
              isWeeklyReportEnabled
              websiteId
            }
            websites {
              id
            }
          }
          memberships {
            account {
              id
            }
            user {
              id
              legacyId
            }
            websites {
              id
            }
          }
          users {
            email
            id
            legacyId
            websiteEmailSettings {
              alertEmailsSetup
              isWeeklyReportEnabled
              websiteId
            }
          }
          websites {
            id
          }
        }
        memberships {
          account {
            id
          }
          user {
            id
            legacyId
          }
          websites {
            id
          }
        }
      }
    }
    website {
      domain
      id
      displayName
      pageCapacity
      permittedActions
    }
  }
}
    `;
export type AddEndUserWebsiteMutationFn = Apollo.MutationFunction<AddEndUserWebsiteMutation, AddEndUserWebsiteMutationVariables>;

/**
 * __useAddEndUserWebsiteMutation__
 *
 * To run a mutation, you first call `useAddEndUserWebsiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEndUserWebsiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEndUserWebsiteMutation, { data, loading, error }] = useAddEndUserWebsiteMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      acceptedLegalDocuments: // value for 'acceptedLegalDocuments'
 *      domain: // value for 'domain'
 *      fetchingLocation: // value for 'fetchingLocation'
 *      httpAuthCredentials: // value for 'httpAuthCredentials'
 *      pageCapacity: // value for 'pageCapacity'
 *      skipValidation: // value for 'skipValidation'
 *      threeDSecureToken: // value for 'threeDSecureToken'
 *      userAgentSettings: // value for 'userAgentSettings'
 *      allowDefaultAlerts: // value for 'allowDefaultAlerts'
 *      allowDefaultReports: // value for 'allowDefaultReports'
 *   },
 * });
 */
export function useAddEndUserWebsiteMutation(baseOptions?: Apollo.MutationHookOptions<AddEndUserWebsiteMutation, AddEndUserWebsiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEndUserWebsiteMutation, AddEndUserWebsiteMutationVariables>(AddEndUserWebsiteDocument, options);
      }
export type AddEndUserWebsiteMutationHookResult = ReturnType<typeof useAddEndUserWebsiteMutation>;
export type AddEndUserWebsiteMutationResult = Apollo.MutationResult<AddEndUserWebsiteMutation>;
export type AddEndUserWebsiteMutationOptions = Apollo.BaseMutationOptions<AddEndUserWebsiteMutation, AddEndUserWebsiteMutationVariables>;
export const AddTrialWebsiteDocument = gql`
    mutation AddTrialWebsite($accountId: AccountId!, $acceptedLegalDocuments: [LegalDocumentType!]!, $domain: String!, $fetchingLocation: FetchingLocation, $httpAuthCredentials: HttpAuthCredentials, $pageCapacity: Int!, $skipValidation: Boolean!, $userAgentSettings: UserAgentSettingsInput) {
  AddTrialWebsite(
    accountId: $accountId
    acceptedLegalDocuments: $acceptedLegalDocuments
    domain: $domain
    fetchingLocation: $fetchingLocation
    httpAuthCredentials: $httpAuthCredentials
    pageCapacity: $pageCapacity
    skipValidation: $skipValidation
    userAgentSettings: $userAgentSettings
  ) {
    query {
      authenticatedSession {
        accounts {
          id
          invitations {
            id
            websiteEmailSettings {
              alertEmailsSetup
              isWeeklyReportEnabled
              websiteId
            }
            websites {
              id
            }
          }
          memberships {
            account {
              id
            }
            user {
              id
              legacyId
            }
            websites {
              id
            }
          }
          users {
            email
            id
            legacyId
            websiteEmailSettings {
              alertEmailsSetup
              isWeeklyReportEnabled
              websiteId
            }
          }
          websites {
            id
          }
        }
        memberships {
          account {
            id
          }
          user {
            id
            legacyId
          }
          websites {
            id
          }
        }
      }
    }
    website {
      domain
      id
      displayName
      pageCapacity
      permittedActions
    }
  }
}
    `;
export type AddTrialWebsiteMutationFn = Apollo.MutationFunction<AddTrialWebsiteMutation, AddTrialWebsiteMutationVariables>;

/**
 * __useAddTrialWebsiteMutation__
 *
 * To run a mutation, you first call `useAddTrialWebsiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTrialWebsiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTrialWebsiteMutation, { data, loading, error }] = useAddTrialWebsiteMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      acceptedLegalDocuments: // value for 'acceptedLegalDocuments'
 *      domain: // value for 'domain'
 *      fetchingLocation: // value for 'fetchingLocation'
 *      httpAuthCredentials: // value for 'httpAuthCredentials'
 *      pageCapacity: // value for 'pageCapacity'
 *      skipValidation: // value for 'skipValidation'
 *      userAgentSettings: // value for 'userAgentSettings'
 *   },
 * });
 */
export function useAddTrialWebsiteMutation(baseOptions?: Apollo.MutationHookOptions<AddTrialWebsiteMutation, AddTrialWebsiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTrialWebsiteMutation, AddTrialWebsiteMutationVariables>(AddTrialWebsiteDocument, options);
      }
export type AddTrialWebsiteMutationHookResult = ReturnType<typeof useAddTrialWebsiteMutation>;
export type AddTrialWebsiteMutationResult = Apollo.MutationResult<AddTrialWebsiteMutation>;
export type AddTrialWebsiteMutationOptions = Apollo.BaseMutationOptions<AddTrialWebsiteMutation, AddTrialWebsiteMutationVariables>;
export const ReviveTrialByAddingWebsiteDocument = gql`
    mutation ReviveTrialByAddingWebsite($accountId: AccountId!, $acceptedLegalDocuments: [LegalDocumentType!]!, $domain: String!, $fetchingLocation: FetchingLocation, $httpAuthCredentials: HttpAuthCredentials, $pageCapacity: Int!, $skipValidation: Boolean!, $userAgentSettings: UserAgentSettingsInput) {
  ReviveTrialByAddingWebsite(
    accountId: $accountId
    acceptedLegalDocuments: $acceptedLegalDocuments
    domain: $domain
    fetchingLocation: $fetchingLocation
    httpAuthCredentials: $httpAuthCredentials
    pageCapacity: $pageCapacity
    skipValidation: $skipValidation
    userAgentSettings: $userAgentSettings
  ) {
    query {
      account(id: $accountId) {
        features {
          feature
          id
        }
        id
        isCleanedUp
        isSuitableForTrialRevival
        isTrialBarDisplayed
        isTrialExtensionAllowed
        memberships {
          account {
            id
          }
          user {
            id
            legacyId
          }
          websites {
            id
          }
        }
        pageBundle
        phase
        plan
        premiumTrialOffer {
          durationInDays
          plan
        }
        state
        trialExpirationDate
      }
      authenticatedSession {
        accounts {
          id
          invitations {
            id
            websiteEmailSettings {
              alertEmailsSetup
              isWeeklyReportEnabled
              websiteId
            }
            websites {
              id
            }
          }
          memberships {
            account {
              id
            }
            user {
              id
              legacyId
            }
            websites {
              id
            }
          }
          users {
            email
            id
            legacyId
            websiteEmailSettings {
              alertEmailsSetup
              isWeeklyReportEnabled
              websiteId
            }
          }
          websites {
            id
          }
        }
        memberships {
          account {
            id
          }
          user {
            id
            legacyId
          }
          websites {
            id
          }
        }
      }
    }
    website {
      domain
      id
      displayName
      pageCapacity
      permittedActions
    }
  }
}
    `;
export type ReviveTrialByAddingWebsiteMutationFn = Apollo.MutationFunction<ReviveTrialByAddingWebsiteMutation, ReviveTrialByAddingWebsiteMutationVariables>;

/**
 * __useReviveTrialByAddingWebsiteMutation__
 *
 * To run a mutation, you first call `useReviveTrialByAddingWebsiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviveTrialByAddingWebsiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviveTrialByAddingWebsiteMutation, { data, loading, error }] = useReviveTrialByAddingWebsiteMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      acceptedLegalDocuments: // value for 'acceptedLegalDocuments'
 *      domain: // value for 'domain'
 *      fetchingLocation: // value for 'fetchingLocation'
 *      httpAuthCredentials: // value for 'httpAuthCredentials'
 *      pageCapacity: // value for 'pageCapacity'
 *      skipValidation: // value for 'skipValidation'
 *      userAgentSettings: // value for 'userAgentSettings'
 *   },
 * });
 */
export function useReviveTrialByAddingWebsiteMutation(baseOptions?: Apollo.MutationHookOptions<ReviveTrialByAddingWebsiteMutation, ReviveTrialByAddingWebsiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReviveTrialByAddingWebsiteMutation, ReviveTrialByAddingWebsiteMutationVariables>(ReviveTrialByAddingWebsiteDocument, options);
      }
export type ReviveTrialByAddingWebsiteMutationHookResult = ReturnType<typeof useReviveTrialByAddingWebsiteMutation>;
export type ReviveTrialByAddingWebsiteMutationResult = Apollo.MutationResult<ReviveTrialByAddingWebsiteMutation>;
export type ReviveTrialByAddingWebsiteMutationOptions = Apollo.BaseMutationOptions<ReviveTrialByAddingWebsiteMutation, ReviveTrialByAddingWebsiteMutationVariables>;